'use client'

const personas = [
  {
    role: 'Professionals',
    icon: 'briefcase',
    headline: <>Manage meetings, notes &amp; priorities &mdash; <em>hands-free.</em></>,
    benefits: ['Manage meetings & follow-ups', 'Plan priorities', 'Get AI summaries'],
  },
  {
    role: 'Students',
    icon: 'graduation',
    headline: <>Record lectures, summarize instantly, <em>stay exam-ready.</em></>,
    benefits: ['Record lectures', 'Get instant summaries', 'Plan assignments'],
  },
  {
    role: 'Entrepreneurs',
    icon: 'rocket',
    headline: <>Run your team &amp; schedule effortlessly <em>with AVA.</em></>,
    benefits: ['Capture client notes', 'Auto-schedule', 'Track team progress'],
  },
]

export default function Personas() {
  return (
    <div className="personas">
      {personas.map((p) => (
        <div className="persona" key={p.role}>
          <div className="ico"><PersonaIcon kind={p.icon} /></div>
          <div className="role-key">{p.role}</div>
          <h3>{p.headline}</h3>
          <ul>
            {p.benefits.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        </div>
      ))}
    </div>
  )
}

function PersonaIcon({ kind }) {
  const c = {
    width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth: 1.6,
    strokeLinecap: 'round', strokeLinejoin: 'round',
  }
  if (kind === 'briefcase') return (
    <svg {...c}>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </svg>
  )
  if (kind === 'graduation') return (
    <svg {...c}>
      <path d="M2 9l10-5 10 5-10 5L2 9z" />
      <path d="M6 11v5c0 1 3 2.5 6 2.5s6-1.5 6-2.5v-5" />
      <path d="M22 9v5" />
    </svg>
  )
  if (kind === 'rocket') return (
    <svg {...c}>
      <path d="M5 19s-1-3 1-6c2-3 5-5 9-6 0 4-2 7-5 9-3 2-5 3-5 3z" />
      <path d="M14 8a2 2 0 1 1 3 3" />
      <path d="M5 19c-1 1-1 3-1 3s2 0 3-1" />
    </svg>
  )
  return null
}
